import type { ReactNode } from 'react'
import { useEffect } from 'react'
import { useLocation } from '#router'
import { useFeatureFlag } from '@/hooks/use-feature-flag'
import { MARKETING_PAGES_FLAG } from '@/lib/marketing-content'
import LoadingFallback from './loading-fallback'

/**
 * Public route guard for the marketing pages, gated on the
 * enable-marketing-pages PostHog flag. Unlike FeatureFlagRoute, no auth is
 * required and a disabled flag redirects to the dashboard instead of 404ing.
 * Admins bypass the flag (useFeatureFlag default) so they can preview.
 */
export function MarketingPageRoute({ children }: { children: ReactNode }) {
  const { enabled, isLoaded } = useFeatureFlag(MARKETING_PAGES_FLAG)
  const { navigate } = useLocation()

  useEffect(() => {
    if (isLoaded && !enabled) {
      navigate('/', { replace: true })
    }
  }, [isLoaded, enabled, navigate])

  if (!isLoaded || !enabled) {
    return <LoadingFallback />
  }

  return <>{children}</>
}
